export default {
  name: 'toLower',
  filter: function (value) {
    return value.toLowerCase()
  }
}
